const CustomResourceApplySG = () => import('@/views/main/report/customResourceApply/CustomResourceApplySG.vue')
export default {
  path: '/main/report/customResourceApplySG',
  name: 'customResourceApplySG',
  component: CustomResourceApplySG,
  children: []
}
